export const getFileExtension = (fileName: string): string => fileName.split(".").at(-1) as string;
